(() => {
  if (!window.gsap) return;
  gsap.registerPlugin(ScrollTrigger);
  const mm = gsap.matchMedia();
  mm.add('(prefers-reduced-motion: no-preference)', () => {
    document.querySelectorAll('[data-reveal]').forEach((el) => {
      gsap.fromTo(el, { autoAlpha: 0, y: 36 },
        { autoAlpha: 1, y: 0, duration: 1, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 85%' } });
    });
    document.querySelectorAll('[data-reveal-group]').forEach((group) => {
      gsap.fromTo(group.children, { autoAlpha: 0, y: 30 },
        { autoAlpha: 1, y: 0, duration: 0.9, ease: 'power3.out', stagger: 0.12,
          scrollTrigger: { trigger: group, start: 'top 85%' } });
    });
    document.querySelectorAll('[data-parallax]').forEach((el) => {
      const amt = parseFloat(el.dataset.parallax) || 0.15;
      gsap.to(el, { yPercent: amt * 100, ease: 'none',
        scrollTrigger: { trigger: el.parentElement, scrub: true } });
    });
    const heroItems = document.querySelectorAll('[data-hero-item]');
    if (heroItems.length)
      gsap.fromTo(heroItems, { autoAlpha: 0, y: 40 },
        { autoAlpha: 1, y: 0, duration: 1.1, ease: 'power3.out', stagger: 0.14, delay: 0.15 });
  });
  if (matchMedia('(prefers-reduced-motion: reduce)').matches)
    document.querySelectorAll('[data-hero-video]').forEach(v => { v.pause(); v.removeAttribute('autoplay'); });
})();
